import './style/editNameDialog.scss';
import React from 'react';
import {useTranslation} from 'react-i18next';
import SpinnerIcon from '../../icon/spinnerIcon';
import BolProduct from '../../../models/bolProductModel';
import {BluemateButton, BluemateDialog, BluemateInput, BluemateTooltip} from '../../controls';

interface Props {
    onClose: VoidFunction;
    onChangeName: (value: string) => void;
    onResetName: VoidFunction;
    resetting: boolean;
    onSubmit: VoidFunction;
    active: boolean;
    product: BolProduct | null;
    name: string;
    canSave: boolean;
    saving: boolean;
}

const MAX_TITLE_LENGTH = 750;

export default function EditNameDialog(props: Props) {
    const {onClose, onChangeName, onResetName, resetting, onSubmit, active, product, name, canSave, saving} = props;
    const {t} = useTranslation();

    return (
        <BluemateDialog
            active={active}
            onClose={onClose}
            title={t('products.editName.title', 'Productnaam aanpassen')}
            subtitle={product ? `EAN: ${product.ean}` : undefined}
            onConfirm={onSubmit}
            confirmLabel={t('products.editName.save', 'Opslaan')}
            cancelLabel={t('products.editName.cancel', 'Annuleren')}
            cancelVariant='tertiary'
            confirmDisabled={!canSave}
            loading={saving}
            className='products-edit-name-dialog'
            width='30rem'
        >
            <p className='edit-name-info'>
                {t(
                    'products.editName.info',
                    'Deze naamswijziging geldt voor de productnaam die op Bluemate en op facturen wordt getoond. Zo kun je een productnaam op Bluemate-facturen bijvoorbeeld korter en herkenbaarder maken.'
                )}
            </p>
            <div className='name-row'>
                <BluemateInput
                    onChange={onChangeName}
                    onEnter={onSubmit}
                    value={name}
                    label={t('products.editName.label', 'Productnaam')}
                    disabled={saving}
                    inputProps={{maxLength: MAX_TITLE_LENGTH}}
                    className='name-field'
                    shape='rounded'
                    uniformFont
                    fullWidth
                    autoFocus
                />
                <BluemateTooltip text={t('settings.vat.useBolName', 'Gebruik Bol naam')}>
                    <div className='reset-name-wrap'>
                        <BluemateButton
                            onClick={onResetName}
                            label={<SpinnerIcon spinning={resetting} className='reset-icon' />}
                            disabled={saving || resetting}
                            className='btn-name-reset'
                            size='small'
                            shape='square'
                            tertiary
                        />
                    </div>
                </BluemateTooltip>
            </div>
        </BluemateDialog>
    );
}
